import Vue from 'vue'
import Vant from 'vant';
import { Toast  } from 'vant';
import 'vant/lib/index.css';
Vue.use(Vant);
Vue.use(Toast );



// WEBPACK FOOTER //
// ./src/utils/vant.js